import { clearHighlight } from "../direct.js";

export let FirstMenuTitle = {
  name: 'title',
  title: 'Edit titles',
  shortcut: 't'
}
export function queryTitle(uid, title) {
  let query = `#title-${uid} div[name="${title.name}"]`;
  return document.querySelector(query);
}
export function queryMultiplesHeader(uid) {
  let query = `#view-${uid} g.role-scope.${uid}_cell g.mark-group.role-title`;
  return document.querySelectorAll(query);
}
export function findTitle(uid, title, cls) {
  let cls_name = { find: "dupo-g-found", hide: "dupo-g-hidden", unhide: "dupo-g-hidden" }[cls];
  if (title === "multiples") {
    queryMultiplesHeader(uid).forEach((m) => {
      if (m) {
        if (cls === "unhide") { m.classList.remove(cls_name); }
        else { m.classList.add(cls_name); }
      }
    });
  } else {
    if (cls === "unhide") { queryTitle(uid, title)?.classList?.remove(cls_name); }
    else { queryTitle(uid, title)?.classList?.add(cls_name); }

  }
}
export function unfindTitle() {
  clearHighlight();
}

